var React = require('react');

function TickerArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 14.4019L30.9321 14.3602","stroke":"black","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M18.1666 1L31 14.3246L18.1666 27.6492","stroke":"black","strokeWidth":"1.5","key":1})]);
}

TickerArrow.defaultProps = {"width":"33","height":"29","viewBox":"0 0 33 29","fill":"none"};

module.exports = TickerArrow;

TickerArrow.default = TickerArrow;
